import { Component, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';
import { GbprintService, GrundstueckIcpListEntry } from '../../../core/gb-api';
import { sanatizedSaveAs } from '../../functions/file.functions';
import { CapExceptionHandler } from '../../../core/extension/exceptions/cap-exception-handler';
import { GrundstuecknummerPipe } from '../../pipes/simple/grundstuecknummer.pipe';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cap-auszug-icp',
  templateUrl: './auszug-icp.component.html',
  styleUrls: ['./auszug-icp.component.scss'],
  imports: [NgbTooltip, TranslatePipe]
})
export class AuszugIcpComponent {
  @Input()
  gsEntry: GrundstueckIcpListEntry;

  loaded = false;
  isDownloading = false;

  constructor(
    private translate: TranslateService,
    public gbPrintService: GbprintService,
    private capExceptionHandler: CapExceptionHandler,
    private grundstuecknummerPipe: GrundstuecknummerPipe
  ) {
    keysToTranslate(['AuszugErstellen']);
  }

  createGrundstueckAuszug() {
    if (this.gsEntry) {
      this.isDownloading = true;
      const subscription = this.gbPrintService.getGrundstueckAuszugICP(this.gsEntry.id.id, this.translate.currentLang).subscribe({
        next: (responseBody: Blob) => {
          sanatizedSaveAs(
            responseBody,
            this.translate.instant('Auszug') + ' ' + this.grundstuecknummerPipe.transform(this.gsEntry.grundstueckNummer) + '.docx'
          );
        },
        error: (error) => this.capExceptionHandler.handleError(error)
      });
      subscription.add(() => (this.isDownloading = false));
    }
  }
}
